import React, { useContext } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'

import { getCategoryName } from 'components/nav/CategoriesMenu/utils/categories'
import { CategoryCard } from 'components/ui/Card/CategoryCard'
import CategoriesContext from 'contexts/CategoriesContext'

import { SliderElement } from './styles'

type Props = {
  handleSelectCategory: (category: ProductCategory) => void
  selectedCategory: number | undefined
}

export const CategoriesSlider: React.FC<Props> = ({ handleSelectCategory, selectedCategory }) => {
  const { categories } = useContext(CategoriesContext)

  return (
    <Box paddingLeft="20px" marginTop="12px">
      <Flex overflow="scroll" paddingBottom="12px">
        {categories
          .filter((s) => s.parentCategoryId === undefined)
          .map((category) => (
            <SliderElement onClick={() => handleSelectCategory(category)} key={category.id}>
              <CategoryCard
                key={category.id}
                isCategorySelected={category.id === selectedCategory}
                category={{ id: category.id, name: getCategoryName(category), url: category.imageUrl }}
              />
            </SliderElement>
          ))}
      </Flex>
    </Box>
  )
}
